var createRange=require("./_createRange"),range=createRange();module.exports=range;